module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai625-4e10ad4f8b024d43987ad5c30c614b29.jpg";